module.exports = __webpack_public_path__ + "img/logo.348b94a1.png";